import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

const INITIAL_STATE = {
  expandedSubmenu: null,
};

export const PRIVATE_ACTIONS = {
  initStore:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },
};

export const ACTIONS = {
  toggleSubmenu:
    (id) =>
    ({ getState, setState }) => {
      const { expandedSubmenu } = getState();
      setState({ expandedSubmenu: expandedSubmenu !== id ? id : null });
    },

  collapseAllSubmenus:
    () =>
    ({ setState }) => {
      setState({ expandedSubmenu: null });
    },

  getExpandedSubmenu:
    () =>
    ({ getState }) => {
      return getState().expandedSubmenu;
    },
};

export const MainStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'navigation-sidebar',
});
